import React from 'react'
import AppFirst from './AppFirst'
import AppPricing from './AppPricing'
import AppSecond from './AppSecond'
import AppThird from './AppThird'
import ContactSection from './ContactSection'
// import ContactForm from './ContactForm'

const AppDevelopmentPage = () => {
  return (
    <div>
      <AppPricing/>
      <AppFirst/>
      <AppSecond/>
      <AppThird/>
      <ContactSection />
      {/* <ContactForm /> */}
    </div>
  )
}

export default AppDevelopmentPage

